import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../../components/primitives/Panel';
import { SavedTextarea } from '../components/SavedTextarea';
import type { OutreachProfileDto } from '../outreachTypes';
import type { ProfileUpdate } from '../hooks/useProfileActions';
import { profileMessages as messages } from './profileMessages';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ProfileSenderCardProps {
  profile: OutreachProfileDto;
  onSave: (patch: ProfileUpdate) => void;
  disabled: boolean;
}

/** The from name, the postal line and the signature (design outreach e3 "From name"; spec §8.4). */
const ProfileSenderCardComponent: React.FC<ProfileSenderCardProps> = ({ profile, onSave, disabled }) => {
  const intl = useIntl();
  return (
    <Panel as="section">
      <PanelHead title={intl.formatMessage(messages.senderTitle)} />
      <PanelBody>
        <div className={styles.stack}>
          <SavedTextarea
            singleLine
            label={intl.formatMessage(messages.senderName)}
            value={profile.senderName}
            onSave={(senderName) => onSave({ senderName })}
            maxLength={120}
            disabled={disabled}
          />
          <SavedTextarea
            singleLine
            label={intl.formatMessage(messages.senderPostal)}
            value={profile.senderPostal ?? ''}
            onSave={(value) => onSave({ senderPostal: value.trim() === '' ? null : value })}
            maxLength={300}
            disabled={disabled}
          />
          <SavedTextarea
            label={intl.formatMessage(messages.signature)}
            value={profile.signature ?? ''}
            onSave={(value) => onSave({ signature: value.trim() === '' ? null : value })}
            maxLength={600}
            rows={2}
            disabled={disabled}
          />
          <p className={styles.small}>
            {withBrandWord(intl.formatMessage(messages.footerNote, { name: profile.senderName }))}
          </p>
        </div>
      </PanelBody>
    </Panel>
  );
};

export const ProfileSenderCard = TypedMemo(ProfileSenderCardComponent);
